import React from "react";
import { History } from "history";
import { Session } from "@intech/react-service";
import { ContratoDisponivelButton, ContratoDisponivelButtonContainer, ListaContrato } from "./styles";
import { PlanoVinculadoEntidade } from "../../entidades";
import { UsuarioService } from "../../services";
import PageClean from "../PageClean";
import { Alerta, TipoAlerta } from "@intechprev/componentes-web";

interface Props {
  history?: History;
}

interface State {
  Loading: boolean;
  Erro: string;
  Contratos: Array<PlanoVinculadoEntidade>;
}

export class SelecionarContrato extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      Loading: true,
      Erro: "",
      Contratos: []
    };
  }

  componentDidMount = async () => {
    this.setState({ Loading: true });
    try {
      const Contratos = await UsuarioService.BuscarContratos();
      this.setState({ Contratos });
    } catch (e) {
      const err: any = e;
      this.setState({ Erro: err.respose ? err.response.data : err });
    }
    finally {
      this.setState({ Loading: false });
    }
  }

  selecionar = async (SQ_CONTRATO_TRABALHO: number) => {
    this.setState({ Loading: true });
    try {
      const login = await UsuarioService.SelecionarContrato(SQ_CONTRATO_TRABALHO, 1);
      await Session.setToken(login.AccessToken);

      this.props.history.push("/");
    } catch (e) {
      const err: any = e;
      this.setState({ Erro: err.respose ? err.response.data : err });
    }
    finally {
      this.setState({ Loading: false });
    }
  }

  render() {
    return (
      <PageClean {...this.props}>
        {this.state.Loading && <Alerta tipo={TipoAlerta.info} mensagem={"Carregando..."} />}

        {!this.state.Loading && this.state.Erro !== "" && <Alerta tipo={TipoAlerta.danger} mensagem={this.state.Erro} />}

        {!this.state.Loading && this.state.Erro === "" && <>
          <h5>
            <b>
              {"Encontramos os seguintes contratos vinculados ao seu CPF. Para continuar no Portal favor selecionar uma opção abaixo:"}
            </b>
          </h5>

          <ListaContrato>
            {this.state.Contratos.map((contrato, index) => {
              return (
                <ContratoDisponivelButtonContainer key={index}>
                  <ContratoDisponivelButton onClick={() => this.selecionar(contrato.SQ_CONTRATO_TRABALHO)}>
                    <b>{contrato.DS_PLANO_PREVIDENCIAL}</b>
                    <div>Situação: {contrato.DS_SIT_PLANO}</div>
                    <div>Matrícula: {contrato.NR_REGISTRO}</div>
                  </ContratoDisponivelButton>
                </ContratoDisponivelButtonContainer>
              );
            })}
          </ListaContrato>
        </>}
      </PageClean>
    );
  }
}